/**
 * TypeScript types for User Management
 */

export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  CLIENT_ADMIN = 'CLIENT_ADMIN',
  FACILITY_ADMIN = 'FACILITY_ADMIN',
  ADMIN = 'ADMIN',
  NURSE = 'NURSE',
  DOCTOR = 'DOCTOR',
  SOCIAL_WORKER = 'SOCIAL_WORKER',
  PHARMACIST = 'PHARMACIST',
  BILLING_SPECIALIST = 'BILLING_SPECIALIST',
  OFFICER = 'OFFICER',
  ENGINEER = 'ENGINEER',
}

export interface UserDTO {
  id?: string;
  keycloakId?: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role?: UserRole | string;
  password?: string;
  isActive?: boolean;
  emailVerified?: boolean;
  profilePictureUrl?: string;
  employeeId?: string;
  licenseNumber?: string;
  department?: string;
  jobTitle?: string;
  hireDate?: string;
  lastLoginAt?: string;
  lastLogin?: string;
  notes?: string;
  tenantId?: string;
  facilityId?: string;
  clientId?: string;
  createdAt?: string;
  updatedAt?: string;
  fullName?: string;
  roles?: string[];
  facilityIds?: string[];
  facilityNames?: string[];
  facility?: { id: string; name: string }[];
  accountLocked?: boolean;
}

export interface CreateUserRequest {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  password?: string;
  isActive?: boolean;
  emailVerified?: boolean;
  phone?: string;
  role?: UserRole | string;
  roles?: string[];
  facilityIds?: string[];
  profilePictureUrl?: string;
  employeeId?: string;
  licenseNumber?: string;
  department?: string;
  jobTitle?: string;
  hireDate?: string;
  notes?: string;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}
